// src/api/tileUrl.js
//
// THE ONE PLACE A TITILER TILE URL IS BUILT.
//
// nginx sends exactly one shape to the signed tile gateway:
//
//     /tiles/WebMercatorQuad/{z}/{x}/{y}.png?dataset=…&ck=…
//
// (nginx.dev.conf and nginx.prod.conf, `location ~ ^/tiles/WebMercatorQuad/
// (?<z>\d+)/(?<x>\d+)/(?<y>\d+)\.png$`). Any other /tiles/ path is not a tile.
// Until fix/tiles-and-projects nginx answered those with a 200 and 199 bytes
// of text labelled image/png, so a URL missing ".png" drew nothing and said
// nothing: PadPlanner's imagery never drew until 13623736, and the Operator
// Portal reviewer map's never did. Eight sites built the URL by hand; they all
// build it here now, and api/tileUrl.scan.test.js refuses a /tiles/ literal
// anywhere else in ui/src.
//
// The tile token is NOT a parameter: it rides as X-Tile-Token through the
// map's transformRequest, which keeps the URL stable across token refreshes.
// Well3DSurface still puts tile_token in its query string; that is filed
// separately and is its own code, not this module's.

/** The gateway's path prefix, for code that recognizes a tile URL. */
export const TILE_PATH = "/tiles/WebMercatorQuad";

/** The gateway's path for one tile; MapLibre's {z}/{x}/{y} by default. */
export function tilePath(z = "{z}", x = "{x}", y = "{y}") {
  return `${TILE_PATH}/${z}/${x}/${y}.png`;
}

/**
 * A raster source's tile URL: the dataset, the session's cache key, and the
 * operating AOI when there is one (last).
 * @param {string} datasetKey
 * @param {string} ck  the tile_cache_key /tile/session issued
 * @param {{operatingAoi?: string|null}} [opts]
 */
export function tileUrl(datasetKey, ck, { operatingAoi = null } = {}) {
  const aoi = operatingAoi ? `&operating_aoi=${encodeURIComponent(operatingAoi)}` : "";
  return `${tilePath()}?dataset=${encodeURIComponent(datasetKey)}&ck=${encodeURIComponent(ck)}${aoi}`;
}
